import Checkbox from '@material-ui/core/Checkbox';

/** @deprecated Exporting the Checkbox component from the material-ui library. */
export default Checkbox;
